import React from "react";
import PropTypes from "prop-types";
const InputWarningMessage = ({ message, type }) => {
  if (!message) return null;

  switch (type) {
    case "info":
      return <span className="text-info">{message}</span>;
    case "warning":
      return <span className="text-warning">{message}</span>;
    case "success":
      return <span className="text-success">{message}</span>;
    case "danger":
      return <span className="text-danger">{message}</span>;
    case "primary":
      return <span className="text-primary">{message}</span>;
    case "secondary":
      return <span className="text-secondary">{message}</span>;

    default:
      return <span className="text-secondary">{message}</span>;
  }
};

InputWarningMessage.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default InputWarningMessage;
